//react
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import axios from 'axios'

//redux
import { createStore, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'
import { rootReducer } from 'rootReducer'

//utils
import { setAuthorisationHeader, setAdvisorClientHeader } from 'globals/utils'
import { userLoggedIn, timedout, logout } from 'data/auth/action'
import { getUserData } from 'data/user/action'

//components
import App from './App'
import reportWebVitals from './reportWebVitals'

//css
import './semantic.min.css'
import './colours.css'
import './index.css'
import './fonts/css/navigator.css'

import dayjs from 'dayjs'
import customParseFormat from 'globals/customParseFormat'
dayjs.extend(customParseFormat)

const store = createStore(rootReducer, applyMiddleware(thunk))

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
    console.log(error)
    //catches if the session ended!
    if ( error && error.response ) {
      switch (error.response.status) {
        case 401:           
          store.dispatch(logout('/app/timeout'))/* .catch(err=>{
            window.location.replace('/app/login')
          }) */
          break
        case 500:
          store.dispatch(logout('/app/error'))/* .catch(err=>{
            window.location.replace('/app/login')
          }) */
          break
        default:
          break
      }
    }
    return Promise.reject(error)
})

if (sessionStorage.token && !isAnnon(window.location.pathname)){
  const { token, status, subscription, userName, currentClient, lastLogin } = sessionStorage
  setAuthorisationHeader(token)
  if (status==='advisor' && currentClient) { 
    setAdvisorClientHeader(currentClient)
  }
  store.dispatch(userLoggedIn({token, status, subscription, userName, lastLogin}))
  if(status !== 'advisor' && status !== 'admin'){ 
    store.dispatch(getUserData(token)).catch(err=>{
      window.location.replace('/app/login')
    })
  }
}

function isAnnon(location) {
  if (location.includes('/login')) {
    return true
  } else if (location.includes('/signup')) {
    return true
  } else if (location.includes('/forgotpassword')) {
    return true
  } else if (location.includes('/resetpassword')) {
    return true
  } else if (location.includes('/resetsent')) {
    return true
  } else if (location.includes('/acceptinvitation')) {
    return true
  } else if (location.includes('/confirmemail')) {
    return true
  } else if (location.includes('/confirmation')) {
    return true
  }
}

ReactDOM.render(
  <BrowserRouter basename={'/app'}>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>, document.getElementById('root')
)

document.body.style.backgroundColor = process.env.REACT_APP_BACKGROUND

if (module.hot) {module.hot.accept();}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
